export default __webpack_public_path__ + "media/images/file_types/excel-a490121f76c451a2c37eeda6a7961a04.svg";